import Button from '@rio-cloud/rio-uikit/Button';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import { useIntl } from 'react-intl';

import type { UploadDocumentTarget } from '#api-bridge/documentApi.ts';
import type { Document } from '#domain/Document.ts';

import { DocumentUpload } from './DocumentUpload.tsx';

type CreateOrderDialogProps = {
    shown: boolean;
    onClose: () => void;
    associations: Document['associations'];
    uploadTarget: UploadDocumentTarget;
};

export const DocumentUploadDialog = ({ shown, onClose, associations, uploadTarget }: CreateOrderDialogProps) => {
    const intl = useIntl();
    const dialogTitleId = 'intl-msg:ordercom-cloud-frontend.common.upload';
    return (
        <Dialog
            show={shown}
            onClose={onClose}
            showCloseButton={false}
            bsSize='md'
            data-testid={'order-dialog-document-upload-dialog'}
            title={intl.formatMessage({
                id: dialogTitleId,
                defaultMessage: 'Upload',
            })}
            body={<DocumentUpload onClose={onClose} associations={associations} uploadTarget={uploadTarget} />}
            headerButtons={
                <Button
                    bsStyle={Button.MUTED}
                    iconOnly
                    iconName='rioglyph-remove'
                    autoTrackingKey={`${dialogTitleId}.close`}
                    className='modal-header-close close'
                    onClick={onClose}
                    aria-label='dialog close button'
                />
            }
        />
    );
};
